import { Box, Item, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { A3innuvaCompaniesLegalEntitiesFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import type { WizardData } from 'modules/marketplace/lib/types'

import { MappingTable } from './MappingTable'

interface CompanyLegalEntityFillerProps extends WizardStepRenderParams<WizardData> {
  options: Item[]
  legalEntities: A3innuvaCompaniesLegalEntitiesFragment[]
}

export const CompanyLegalEntityFiller = ({
  data,
  onDataChanged,
  options,
  legalEntities,
  loading,
}: CompanyLegalEntityFillerProps) => {
  const setFormValues = (value: Item, legalEntity: A3innuvaCompaniesLegalEntitiesFragment) => {
    onDataChanged({
      ...data,
      answers: {
        ...data.answers,
        [`legal_entity_${legalEntity.id}`]: value['value'].toString(),
      },
    })
  }

  const findLegalEntity = (legalEntityId: string) => {
    const selection = data.answers[`legal_entity_${legalEntityId}`]
    if (!selection) return ''
    return options.find((option) => option.value === selection)?.label || ''
  }

  return (
    <Box gap="s24">
      <MappingTable
        title={i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.mapping_table.a3innuva_fields'
        )}
        items={legalEntities}
        options={options}
        getItemId={(item) => item.id.toString()}
        getItemLabel={(item) => item.legalName}
        onSelect={setFormValues}
        findSelection={findLegalEntity}
        disabled={data.answers.workplaces_codes_enabled === 'false'}
        loading={loading}
        selectPlaceholder={i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.company.legal_entity_code.select'
        )}
      />
    </Box>
  )
}
